module.exports = __webpack_public_path__ + "img/level-2-stand.a12b2ffa.svg";